import { IEventBundleConfiguration } from "../../models/configuration/bundles/IBundles";
import { Action, ActionType } from "../actions";

interface ConfigBundlesState {
  loading: boolean;
  error: string | null;
  data: IEventBundleConfiguration | null;
  persistedData: IEventBundleConfiguration | null;
}

const initialState = { loading: false, error: null, data: null, persistedData: null };

const cloneEventBundleConfig = (payload: IEventBundleConfiguration | null): IEventBundleConfiguration | null => {
  if (!payload) return payload;
  return JSON.parse(JSON.stringify(payload)) as IEventBundleConfiguration;
};

const configEventBundlesReducer = (
  state: ConfigBundlesState = initialState,
  action: Action
): ConfigBundlesState => {
  switch (action.type) {
    // GET DATA
    case ActionType.GET_CONFIG_BUNDLE_EVENT_DATA:
      return { ...state, loading: true, error: null };
    case ActionType.GET_CONFIG_BUNDLE_EVENT_DATA_FAILURE:
      return { ...state, loading: false, error: action.payload, persistedData: state.persistedData };
    case ActionType.GET_CONFIG_BUNDLE_EVENT_DATA_SUCCESS: {
      const persistedData = action.fromServer
        ? cloneEventBundleConfig(action.payload)
        : state.persistedData;
      return { ...state, loading: false, error: null, data: action.payload, persistedData };
    }

    // SAVE DATA
    case ActionType.SAVE_CONFIG_BUNDLE_EVENT_DATA:
      return { ...state, loading: true };
    case ActionType.SAVE_CONFIG_BUNDLE_EVENT_DATA_FAILURE:
      return { ...state, loading: false, error: action.payload, persistedData: state.persistedData };
    case ActionType.SAVE_CONFIG_BUNDLE_EVENT_DATA_SUCCESS:
      return { ...state, loading: false, error: null, data: action.payload, persistedData: cloneEventBundleConfig(action.payload) };
    case ActionType.CONFIG_ID_CHANGED:
      return initialState;
    default:
      return state;
  }
};

export default configEventBundlesReducer;